import { httpAuth } from "@/api/httpAuth";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

const adminGroupHeader = { [GROUP_AUTH_HEADER_NAME]: "admin" };

export const adminRequests = {
  change_automatic_payment_enabled: function ({ data } = {}) {
    return httpAuth
      .post("/v1/admin/change_automatic_payment_enabled", { headers: adminGroupHeader, json: data })
      .json();
  },

  change_patient_email: function ({ data }) {
    return httpAuth.post("/v1/admin/change_patient_email", { json: data }).json();
  },

  change_patient_practice: function ({ data }) {
    return httpAuth.post("/v1/admin/change_patient_practice", { json: data }).json();
  },

  change_provider_practice: function ({ data } = {}) {
    return httpAuth
      .post("/v1/admin/change_provider_practice", { headers: adminGroupHeader, json: data })
      .json();
  },

  change_provider_status: function ({ context, data } = {}) {
    return httpAuth
      .post("/v1/admin/change_provider_status", { context, headers: adminGroupHeader, json: data })
      .json();
  },

  delete_provider_from_care_team: function ({ searchParams, urlParams }) {
    const { providerId } = searchParams;
    const { patientId } = urlParams;

    return httpAuth
      .post(`/v1/patient_management/${patientId}/delete_provider_from_care_team`, {
        headers: adminGroupHeader,
        searchParams: { providerId },
      })
      .json();
  },

  fetch_insurance_eligibility_records: function ({ data }) {
    return httpAuth.post("/v1/insurance_eligibility/get_eligibility", { json: data }).json();
  },

  fetch_patient_list: function ({ searchParams } = {}) {
    return httpAuth
      .post("/v1/provider/patient_list", {
        context: { showLoader: false },
        headers: adminGroupHeader,
        // ky drops undefined-valued keys before building the query string,
        // so omitting both practiceId and providerId sends no params at all
        // (backend returns all patients for the admin group in that case)
        searchParams: {
          practice_id: searchParams?.practiceId,
          provider_id: searchParams?.providerId,
        },
      })
      .json();
  },

  fetch_practice_providers: function ({ data, searchParams }) {
    return httpAuth
      .post("/v1/practice/all_practice_providers", {
        context: { showLoader: false },
        headers: adminGroupHeader,
        json: data,
        searchParams: { practice_id: searchParams.practiceId },
      })
      .json();
  },

  fetch_providers: function ({ searchParams }) {
    const { providerTypes } = searchParams;

    return httpAuth
      .post("/v1/admin/get_providers", {
        context: { showLoader: false },
        headers: adminGroupHeader,
        searchParams: { provider_types: providerTypes },
      })
      .json();
  },

  fetch_providers_by_pcp_practice_id: function ({ context, data } = {}) {
    return httpAuth
      .post("/v1/admin/get_providers_by_pcp_practice_id", {
        context,
        headers: adminGroupHeader,
        json: data,
      })
      .json();
  },

  get_provider_inactivation_options: function () {
    return httpAuth
      .post("/v1/admin/get_provider_inactivation_options", { headers: adminGroupHeader })
      .json();
  },

  post_practice: function ({ data }) {
    return httpAuth
      .post("/v1/practice/add_practice", { headers: adminGroupHeader, json: data })
      .json();
  },

  reset_patient_password: function ({ data }) {
    return httpAuth.post("/v1/admin/reset_user_password", { json: data }).json();
  },

  restrict_patient_scheduling: function ({ data }) {
    return httpAuth.post("/v1/admin/restrict_patient_scheduling", { json: data }).json();
  },

  set_provider_universal_access: function ({ data }) {
    return httpAuth.post("/v1/admin/set_provider_universal_access", { json: data }).json();
  },

  trigger_email_verification_email: function ({ data }) {
    return httpAuth.post("/v1/admin/trigger_email_verification_email", { json: data }).json();
  },

  update_practice: function ({ data, searchParams }) {
    return httpAuth
      .post("/v1/practice/update_practice", {
        context: { showLoader: false },
        headers: adminGroupHeader,
        json: data,
        searchParams: { practice_id: searchParams.practiceId },
      })
      .json();
  },
};
